var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav_box"},[_c('span',[_vm._v("跨系统账号转移服务")]),(_vm.$parent.currentPage == 6 && _vm.returnShow)?_c('i',{staticClass:"return_btn",on:{"click":function($event){_vm.$parent.currentPage--}}}):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }